import { UntypedFormGroup } from '@angular/forms'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AccountInfoFormSubmitter } from '@se-po/se-household-setup-feature-account-info'
import { UserServiceResources as us } from 'se-resource-types'

export class DocsAccountSubmitter implements AccountInfoFormSubmitter {
  public submitting = false
  public matchingDupe: us.UserDuplicateLookupResult
  public matchingEmail: string

  submit(store: StoreService): void {
    console.log('submit')
  }

  validateAndSubmit(form: UntypedFormGroup, store: StoreService): void {
    console.log('validateAndSubmit', form.value)
  }
}
